/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading */
import React from 'react';

import {
    commonDefaultProps,
    commonPropTypes,
    concatClassNames,
    ypUtilsToClassNames,
    filterProps,
} from '../../Abstrap/Abstrap';

const propTypes = {
    ...commonPropTypes,
};

const defaultProps = {
    ...commonDefaultProps,
    componentClass: 'tr',
};

const TableRow = (props) => {
    const classNames = [
        'c-table__row',
        props.className,
        ...ypUtilsToClassNames(props.ypUtils),
    ];
    return (
        <props.componentClass
            className={concatClassNames(classNames)}
            {...filterProps(propTypes, props)}
        >
            {props.children}
        </props.componentClass>
    );
};

TableRow.propTypes = propTypes;

TableRow.defaultProps = defaultProps;

export default TableRow;
